export default "__VITE_ASSET__Cn0k9i71__"